(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRipple() {
    document.querySelectorAll('.pq-btn').forEach(function (btn) {
      if (btn.dataset.pqRipple) return;
      btn.dataset.pqRipple = '1';
      btn.addEventListener('pointerdown', function (e) {
        if (reduced) return;
        var r = btn.getBoundingClientRect(), size = Math.max(r.width, r.height) * 2.2;
        var el = document.createElement('span');
        el.className = 'pq-ripple';
        el.style.width = el.style.height = size + 'px';
        el.style.left = (e.clientX - r.left - size / 2) + 'px';
        el.style.top = (e.clientY - r.top - size / 2) + 'px';
        btn.appendChild(el);
        el.addEventListener('animationend', function () { el.remove(); });
      });
    });
  }

  function initBuybar() {
    document.querySelectorAll('.pq-buybar').forEach(function (bar) {
      if (bar.dataset.pqInit) return;
      bar.dataset.pqInit = '1';
      var factor = parseFloat(bar.dataset.umbral) || 1.2;
      var umbral = factor * window.innerHeight, visible = false;
      window.addEventListener('resize', function () { umbral = factor * window.innerHeight; });
      window.addEventListener('scroll', function () {
        var pasa = window.scrollY > umbral;
        if (pasa !== visible) { visible = pasa; bar.classList.toggle('pq-show', pasa); }
      }, { passive: true });
    });
  }

  function initCalc() {
    document.querySelectorAll('.pq-calc__card').forEach(function (card) {
      if (card.dataset.pqInit) return;
      card.dataset.pqInit = '1';
      var margen = (parseFloat(card.dataset.margen) || 40) / 100;
      var get = function (k) { return card.querySelector('[data-campo="' + k + '"]'); };
      var oCosto = card.querySelector('[data-salida="costo"]'), oPrecio = card.querySelector('[data-salida="precio"]');
      var n = function (k) { var el = get(k); var v = el ? parseFloat(el.value) : 0; return isFinite(v) && v > 0 ? v : 0; };
      var fmt = function (v) { return '$' + Math.round(v).toLocaleString('es-AR'); };
      var calc = function () {
        var uni = Math.max(1, n('uni'));
        var total = n('ing') + n('pack') + n('gas') + n('hs') * n('vh');
        var costo = total / uni;
        oCosto.textContent = fmt(costo);
        oPrecio.textContent = fmt(Math.ceil(costo * (1 + margen) / 50) * 50);
      };
      card.querySelectorAll('input').forEach(function (i) { i.addEventListener('input', calc); });
      calc();
    });
  }

  function initTracks() {
    document.querySelectorAll('[data-pq-track]').forEach(function (wrap) {
      if (wrap.dataset.pqInit) return;
      wrap.dataset.pqInit = '1';
      var track = wrap.querySelector('.pq-track'), sbar = wrap.querySelector('.pq-scrollbar'), thumb = wrap.querySelector('.pq-thumb');
      if (!track || !sbar || !thumb) return;
      var sync = function () {
        var max = track.scrollWidth - track.clientWidth;
        var w = Math.max(track.clientWidth / track.scrollWidth * 100, 10);
        thumb.style.width = w + '%';
        thumb.style.left = ((max ? track.scrollLeft / max : 0) * (100 - w)) + '%';
      };
      var seek = function (x) {
        var r = sbar.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (x - r.left) / r.width));
        track.scrollLeft = p * (track.scrollWidth - track.clientWidth);
      };
      sbar.addEventListener('pointerdown', function (e) { sbar.classList.add('pq-dragging'); sbar.setPointerCapture(e.pointerId); seek(e.clientX); });
      sbar.addEventListener('pointermove', function (e) { if (sbar.classList.contains('pq-dragging')) seek(e.clientX); });
      ['pointerup', 'pointercancel'].forEach(function (ev) { sbar.addEventListener(ev, function () { sbar.classList.remove('pq-dragging'); }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', function () { requestAnimationFrame(sync); });
      sync();
    });
  }

  function initAll() { initRipple(); initBuybar(); initCalc(); initTracks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
